import { __rest } from "tslib";
import React, { useEffect, useState } from 'react';
import { default as isEmpty } from "@pb/utils/isEmpty";
import cn from 'classnames';
import ProductSizes from "../../../Locator/components/ProductSizes";
import { CTALink } from "../../../../ui/CTA";
import { StoreIcon } from "../../../../ui/Icon";
import BodyText from "../../../../ui/Typography/texts/BodyText";
import getOutOfStockAndInStoreData from '../../helpers/getOutOfStockAndInStoreData';
import PopUp from '../PopUp';
import styles from './SeeMoreStores.module.scss';
const SeeMoreStores = (_a) => {
    var { mySelectedStore, storeSearchData, storeInformationWithSize, onClickEvents, labels } = _a, props = __rest(_a, ["mySelectedStore", "storeSearchData", "storeInformationWithSize", "onClickEvents", "labels"]);
    const [availabilityData, setAvailabilityData] = useState([]);
    const { allProductSizes } = storeSearchData;
    useEffect(() => {
        var _a, _b, _c;
        const selectedStore = (_a = storeInformationWithSize === null || storeInformationWithSize === void 0 ? void 0 : storeInformationWithSize.stores) === null || _a === void 0 ? void 0 : _a[0];
        if (!isEmpty(storeInformationWithSize)) {
            const inStockArticles = (_c = getOutOfStockAndInStoreData((_b = selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.sizes) === null || _b === void 0 ? void 0 : _b.size, allProductSizes)) === null || _c === void 0 ? void 0 : _c.isInStock;
            setAvailabilityData(inStockArticles);
        }
    }, [storeInformationWithSize]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.outerContainer },
            React.createElement("div", { className: styles.container },
                React.createElement("div", { className: styles.innerContainer },
                    React.createElement(StoreIcon, { className: styles.storeIcon, size: "small" }),
                    React.createElement(BodyText, { ellipsis: true, className: cn(styles.someSizesLabel) }, labels === null || labels === void 0 ? void 0 :
                        labels.fisLabel,
                        " \u00A0",
                        React.createElement("span", { className: styles.boldText }, mySelectedStore === null || mySelectedStore === void 0 ? void 0 : mySelectedStore.name)),
                    React.createElement(PopUp, { popUpInfoText: labels === null || labels === void 0 ? void 0 : labels.fisPopUpText, popUpPosition: "top", onClickEvents: onClickEvents })),
                React.createElement(CTALink, Object.assign({ Tag: "button", className: cn(styles.seeSizesLink) }, props), labels === null || labels === void 0 ? void 0 : labels.fisLinkText)),
            React.createElement(ProductSizes, { availableSizesCopy: "", outOfStockCopy: "", productsInStore: availabilityData }))));
};
export default SeeMoreStores;
//# sourceMappingURL=SeeMoreStores.js.map